import type { HistoryData } from '@constants/types'
import { unionBy } from 'lodash'

import { LOAD_HISTORY, UPDATE_HISTORY } from '../actions'

const initialState: HistoryData = {
  distance: [],
  depth: [],
  pressure: [],
  windSpeed: [],
  windDirection: [],
  airTemperature: [],
  seaWaterTemperature: [],
  ecoScore: []
}

const history = (
  previousState = initialState,
  { type, resource, payload }: { type: string; resource: string; payload: HistoryData }
) => {
  if (type === `${LOAD_HISTORY}_${resource}`) {
    return Object.assign({}, previousState, payload)
  } else if (type === `${UPDATE_HISTORY}_${resource}`) {
    const resourceKey = resource.toLowerCase() as keyof typeof previousState
    if (payload[resourceKey]) {
      payload[resourceKey] = unionBy(previousState[resourceKey], payload[resourceKey], 'timestamp')
    }
    return Object.assign({}, previousState, payload)
  } else {
    return previousState
  }
}

export default history
